const de = document.documentElement;

const width =
  window.innerWidth || (de && de.clientWidth) || document.body.clientWidth;
const height =
  window.innerHeight || (de && de.clientHeight) || document.body.clientHeight;

export { width, height };
